<template>
  <div class="header">
    <div>
      <!-- Logo区域 -->
      <div class="logo">
        <img :src="imglog" />
      </div>
    </div>
    <!-- 菜单区域 -->
    <div style="flex: 1;">
      <!-- 根据menuShow控制是否显示菜单 -->
      <el-menu
        v-if="menuShow"
        class="el-menu-demo"
        mode="horizontal"
        active-text-color="#0da883"
      >
        <!-- 遍历menuData生成子菜单 -->
        <el-submenu
          v-for="(item, index) in menuData"
          :key="index"
          :index="item.menuId + ''"
        >
          <!-- 子菜单标题 -->
          <template slot="title">
            <span class="menu-size" style="color: #0da883;">{{
              item.name
            }}</span>
          </template>
          <!-- 子菜单项 -->
          <el-menu-item
            class="menu-size"
            style="z-index: 99999;"
            @click="toPage(children)"
            :index="children.menuId + ''"
            v-for="children in item.children"
            :key="children.menuId"
            >{{ children.name }}</el-menu-item
          >
        </el-submenu>
      </el-menu>
    </div>
    <!-- 用户信息区域 -->
    <div class="user-info">
      <user-info />
    </div>
  </div>
</template>

<script>
import UserInfo from "@/components/UserInfo";
import { org_access_money } from "@/api/user";
export default {
  components: {
    UserInfo
  },
  data() {
    return {
      // Logo图片
      imglog: require("../../assets/img/name.png"),
      // 菜单折叠状态
      isCollapsesss: false,
      // 菜单数据
      menuData: [],
      // 窗口宽度
      windowWidth: document.documentElement.clientWidth,
      // 激活的菜单索引
      activeIndex: "",
      // 是否显示菜单
      menuShow: true,
      // 菜单按钮文字
      menuText: "收起菜单",
      vip: true
    };
  },
  // 组件创建时获取菜单数据和处理logo
  created() {
    this.getWebMenu();
    this.loglog();
  },
  // 监听窗口宽度变化
  watch: {
    windowWidth(val) {
      this.windowWidth = val;
    }
  },
  // 挂载时监听窗口大小变化
  mounted() {
    window.onresize = () => {
      return (() => {
        this.windowWidth = document.documentElement.clientWidth; // 宽
      })();
    };
  },
  methods: {
    // 根据端口号设置不同logo
    loglog() {
      const port = window.location.port;

      if (port == 11301) {
        this.imglog = require("../../assets/img/name河北.png");
      }
    },
    // 控制菜单显示/隐藏
    menuShowClick() {
      if (this.windowWidth < 1030) {
        this.menuShow = !this.menuShow;
        if (this.menuShow) {
          this.menuText = "收起菜单";
        } else {
          this.menuText = "展开菜单";
        }
      } else {
        this.menuShow = true;
        this.menuText = "收起菜单";
      }
    },
    // 菜单选择处理函数（暂未使用）
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    // 获取菜单数据
    getWebMenu() {
      let localMenu = window.localStorage.getItem("menu");
      if (localMenu && localMenu != "undefined") {
        let menu = JSON.parse(localMenu);
        this.menuData = menu.menu12;
      } else {
        // 无菜单数据则退出登录并跳转到登录页
        this.$store.dispatch("user/logout");
        this.$router.push(`/login`);
      }
    },
    // 跳转到指定页面
    toPage(item) {
      window.localStorage.setItem("path", item.url);
      this.$router.push(item.url);
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 60px;
  // border-bottom: 1px solid #eee;
  line-height: 60px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  z-index: 999999;

  // align-items: center;
  .el-row,
  .el-col {
    height: 100%;
  }

  .el-menu-demo {
    width: 100%;
    height: 60px;
    font-weight: bold;
    z-index: 999;
  }

  .el-menu-demo1 {
    width: 100%;
    height: 60px;
    font-weight: bold;
    z-index: 999;
  }

  .el-menu-demo2 {
    width: 100%;
    // height: 500px;
    // overflow: auto;
    font-weight: bold;
    z-index: 999;
  }

  .web-menu {
    color: #0da883;
    font-weight: bold;
    cursor: pointer;
    margin: 0 20px;
  }

  .logo {
    width: 210px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #eee;

    img {
      width: 200px;
    }
  }

  .index-help {
    display: flex;
    align-items: center;
    justify-content: center;
    float: right;

    div {
      margin-right: 10px;
    }
  }
}

// 响应式设计 - 不同屏幕尺寸下的样式调整
@media screen and (max-width: 1400px) {
  .menu-size {
    font-size: 80%;
  }
}

@media screen and (max-width: 1250px) {
  .menu-size {
    font-size: 50%;
  }
}

@media screen and (max-width: 1700px) {
  .user-info {
    display: none;
  }
}

@media screen and (max-width: 1240px) {
  .logo img {
    position: fixed;
    width: 200px;
    height: 60px;
    top: 0;
    left: 0;
  }

  .user-info {
    position: fixed;
    height: 60px;
    top: 0;
    right: 0;
    z-index: 999;
  }

  .el-menu-demo {
    position: fixed;
    top: 0;
    right: 0;
  }
}

@media screen and (max-width: 1120px) {
  .el-submenu {
    background-color: #ffffff;
  }

  .closeMenu {
    position: absolute;
    top: 10px;
    right: 20px;
    z-index: 99999;
  }
}
</style>
